import { FileListFilter, registerFileListFilter } from '@nextcloud/files';
import { t } from '@nextcloud/l10n';
import Vue from 'vue';
import FileListFilterModified from '../components/FileListFilter/FileListFilterModified.vue';
import calendarSvg from '@mdi/svg/svg/calendar.svg?raw';
const startOfToday = () => (new Date()).setHours(0, 0, 0, 0);
/**
 * Available presets
 */
const timePresets = [
    {
        id: 'today',
        label: t('files', 'Today'),
        filter: (time) => time > startOfToday(),
    },
    {
        id: 'last-7',
        label: t('files', 'Last 7 days'),
        filter: (time) => time > (startOfToday() - (7 * 24 * 60 * 60 * 1000)),
    },
    {
        id: 'last-30',
        label: t('files', 'Last 30 days'),
        filter: (time) => time > (startOfToday() - (30 * 24 * 60 * 60 * 1000)),
    },
    {
        id: 'this-year',
        label: t('files', 'This year ({year})', { year: (new Date()).getFullYear() }),
        filter: (time) => time > (new Date(startOfToday())).setMonth(0, 1),
    },
    {
        id: 'last-year',
        label: t('files', 'Last year ({year})', { year: (new Date()).getFullYear() - 1 }),
        filter: (time) => (time > (new Date(startOfToday())).setFullYear((new Date()).getFullYear() - 1, 0, 1)) && (time < (new Date(startOfToday())).setMonth(0, 1)),
    },
];
class ModifiedFilter extends FileListFilter {
    currentInstance;
    currentPreset;
    constructor() {
        super('files:modified', 50);
    }
    mount(el) {
        if (this.currentInstance) {
            this.currentInstance.$destroy();
        }
        const View = Vue.extend(FileListFilterModified);
        this.currentInstance = new View({
            propsData: {
                timePresets,
            },
            el,
        })
            .$on('update:preset', this.setPreset.bind(this))
            .$mount();
    }
    filter(nodes) {
        if (!this.currentPreset) {
            return nodes;
        }
        return nodes.filter((node) => node.mtime === undefined || this.currentPreset.filter(node.mtime.getTime()));
    }
    reset() {
        this.setPreset();
    }
    setPreset(preset) {
        this.currentPreset = preset;
        this.filterUpdated();
        const chips = [];
        if (preset) {
            chips.push({
                icon: calendarSvg,
                text: preset.label,
                onclick: () => this.setPreset(),
            });
        }
        else {
            this.currentInstance?.resetFilter();
        }
        this.updateChips(chips);
    }
}
/**
 * Register the file list filter by modification date
 */
export function registerModifiedFilter() {
    registerFileListFilter(new ModifiedFilter());
}
